import React from 'react'

const ChevronDown = ( ) => (

<svg className="icon" width="15px" height="8px" viewBox="0 0 15 8" version="1.1" xmlns="http://www.w3.org/2000/svg" >
    {/* <!-- Generator: sketchtool 54 (76480) - https://sketchapp.com -->
    <title>399AC92A-054B-4C8D-80B1-984492FB9C95</title>
    <desc>Created with sketchtool.</desc> */}
    <g id="Dashboard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-1199.000000, -69.000000)" fill="#676767" fillRule="nonzero" id="Path">
            <path d="M1213.84652,69.1545894 C1213.63978,68.9484702 1213.30383,68.9484702 1213.09709,69.1545894 L1206.50725,75.7375201 L1199.90449,69.1545894 C1199.69775,68.9484702 1199.3618,68.9484702 1199.15506,69.1545894 C1198.94831,69.3607085 1198.94831,69.6956522 1199.15506,69.9017713 L1206.11961,76.8454106 C1206.22298,76.9484702 1206.35219,77 1206.49433,77 C1206.62354,77 1206.76567,76.9484702 1206.86905,76.8454106 L1213.8336,69.9017713 C1214.05326,69.6956522 1214.05326,69.3607085 1213.84652,69.1545894 Z"></path>
        </g>
    </g>
</svg>
)

export default ChevronDown;